/**
 * Dev-only logging helpers.
 *
 * Wird in Auth-, Data-, und OAuth-Pfaden aufgerufen (auf jedem Page-Load).
 * In Produktion würde `console.log` die Browser-Console zuspammen —
 * daher guarden wir über `NODE_ENV === 'development'`.
 *
 * Für bewusste Error-Logs (Ausnahmen, die auch in Produktion helfen
 * sollen) bitte weiterhin `console.error` direkt verwenden.
 */

const isDev = process.env.NODE_ENV === 'development';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const devLog = (...args: any[]): void => {
    if (isDev) console.log(...args);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const devWarn = (...args: any[]): void => {
    if (isDev) console.warn(...args);
};
